import React, { useContext } from 'react';
import styled from 'styled-components';

import { Box, Text } from 'components';
import { Room } from 'contexts';

import { Form } from './Form';
import { List } from './List';
import { ContextLanguage } from 'contexts';

const Container = styled.div`
  width: 100%;
`;

export const Question = () => {
  const { question } = React.useContext(Room.Context);

  const isVisible = question?.questionTopic?.isVisible || false;
  const isVisibleForm = question?.questionTopic?.isVisibleForm || false;

  console.log('eee', question?.questionTopic);

  const cxtLang = useContext(ContextLanguage);

  if (!isVisible) return null;

  return (
    <Container>
      <Box>
        <Text size="24" type="h3" color="primary" bold>
          {cxtLang.lang === 'pt' && `Envie sua pergunta`}
          {cxtLang.lang === 'en' && `Envie sua pergunta`}
          {cxtLang.lang === 'es' && `Envie sua pergunta`}
        </Text>

        {/* <Text size="24" type="h3" color="primary" bold>
          {cxtLang.lang === 'pt' &&
            `Digite aqui sua pergunra: ${question?.questionTopic?.name[cxtLang.lang]}`}
          {cxtLang.lang === 'en' &&
            `Enter your question here:  ${question?.questionTopic?.name[cxtLang.lang]}`}
          {cxtLang.lang === 'es' &&
            `Ingrese su pregunta aquí: ${question?.questionTopic?.name[cxtLang.lang]}`}
        </Text> //original */}

        <List />

        {isVisibleForm && (
          <>
            <Text size="24" type="h3" color="primary" bold>
              {cxtLang.lang === 'pt' && 'Envie sua pergunta'}
              {cxtLang.lang === 'en' && 'Envie sua pergunta'}
              {cxtLang.lang === 'es' && 'Envie sua pergunta'}
            </Text>
            <Form />
          </>
        )}
      </Box>
    </Container>
  );
};
